module.exports = __webpack_public_path__ + "static/media/welcome-to-dong.35f3a2e8.png";